import { render, staticRenderFns } from "./StudentOnboardingWizard.vue?vue&type=template&id=ea08485a&"
import script from "./StudentOnboardingWizard.vue?vue&type=script&lang=js&"
export * from "./StudentOnboardingWizard.vue?vue&type=script&lang=js&"
import style0 from "./StudentOnboardingWizard.vue?vue&type=style&index=0&id=ea08485a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports